import React from 'react'
import firebaseui from 'firebaseui'

import { auth } from '~/firebase'


interface Props {
  className?: string
  message?: string
  onSuccess: () => any
}

export default class ReAuth extends React.Component<Props, {}> {
  static defaultProps: Partial<Props> = {
    className: '',
    message: 'Reauthentication is required for this operation.',
  }

  ui

  uiConfig = {
    callbacks: {
      signInSuccess: () => {
        this.ui.delete().then(() => {
          this.ui = null
          this.props.onSuccess()
        })

        return false
      }
      // uiShown: () => this.setState({uiShown: true})
    },
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    signInFlow: 'popup',
    signInOptions: auth.currentUser!.providerData.map(p => p!.providerId)
  }

  componentDidMount() {
    setTimeout(() => {
      this.ui = new firebaseui.auth.AuthUI(auth)
      this.ui.start('#firebaseui-reauth-container', this.uiConfig)
    }, 0)
  }

  componentWillUnmount() {
    if (this.ui) this.ui.delete()
  }

  render() {
    const {className, message} = this.props

    return (
      <section className={className}>
        {message}
        <div id="firebaseui-reauth-container"/>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ReAuth.tsx